"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const DetailNotiScreen = (props) => {
    const { idNoti } = props?.route?.params;
    const [data, setData] = (0, react_1.useState)();
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const stringToDateFormat = (time) => {
        if (!time)
            return '';
        const currentTime = (0, moment_1.default)();
        const createTime = (0, moment_1.default)(time);
        const duration = moment_1.default.duration(currentTime.diff(createTime));
        const minutesDiff = +duration.asMinutes().toFixed(0);
        const hDiff = +duration.asHours().toFixed(0);
        const sameDay = currentTime.isSame(createTime, 'day');
        if (!sameDay) {
            return (0, moment_1.default)(time).format('YYYY/MM/DD');
        }
        else if (minutesDiff <= 1) {
            return '1分以内';
        }
        else if (minutesDiff < 60 && minutesDiff > 1) {
            return `${minutesDiff}分前`;
        }
        else if (hDiff < 24 && hDiff >= 1) {
            return `${hDiff}時間前`;
        }
        return (0, moment_1.default)(time).format('YYYY/MM/DD H:mm');
    };
    (0, react_1.useEffect)(() => {
        if (connected) {
            const { firebase } = require('../../../../web/firebase/config');
            try {
                firebase
                    .firestore()
                    .collection('users')
                    .doc(dataUser?.user_id?.toString())
                    .collection('boxNotifications')
                    .doc(idNoti)
                    .get()
                    .then((res) => {
                    setData(res.data());
                })
                    .catch((err) => {
                    console.log('====', err);
                });
            }
            catch (err) {
                console.log('err', err);
            }
        }
    }, [dataUser?.user_id?.toString(), connected]);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
            justifyContent: 'space-between',
            paddingBottom: 70,
        } },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                    alignSelf: 'center',
                }, title: '通知・お知らせ', styleContainer: {
                    backgroundColor: 'white',
                }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#292A33' }) }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainDetail },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.textTitle }, data?.title || '運営からのお知らせ'),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTime }, stringToDateFormat(data?.postDatetime || data?.createdAt)),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textDes }, data?.description)))));
};
exports.default = DetailNotiScreen;
